import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import AcademicReportsTable from '../parts/AcademicReports/AcademicReportsTable';
import AcademicReportsDetailsDialog from '../parts/AcademicReports/AcademicReportsDetailsDialog';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class AcademicReportsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      isDialogOpen: false,
      selectedAcademicReport: null,
    };

    this.axiosCancel = null;

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onDetailsButtonClick = this.onDetailsButtonClick.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
      selectedAcademicReport: null,
    });
  }

  onDetailsButtonClick(entry) {
    this.setState({
      isDialogOpen: true,
      selectedAcademicReport: entry,
    });
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    return axios
      .get(
        `${window.apiUrl}/getacademicreports?pupil_id=${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.setState({
            data: data,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      isLoaded,
      isLoading,
      data,
      isDialogOpen,
      selectedAcademicReport,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="academic-reports-page">
        <Typography
          className={classes.sectionHeading}
          variant="h5"
          component="h5"
        >
          {t('Academic reports')}
        </Typography>
        <br />
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {isLoaded && data.length === 0 && (
          <p>{t('You currently have no academic reports')}</p>
        )}
        {isLoaded && data.length > 0 && (
          <AcademicReportsTable
            entries={data}
            reloadData={this.reloadData}
            onEntryClick={this.onDetailsButtonClick}
            useSuspense={false}
          />
        )}
        <AcademicReportsDetailsDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={this.onDialogClose}
          academicReport={selectedAcademicReport}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(AcademicReportsPage))
);
